<template>
    <div id="geHome">
        <button @click="$emit('gefahrnummerActive')" id="gefahrnummer">Gefahrnummer</button><br>
        <input type="number" placeholder="UN-Nummer" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"><br>
        <button @click="$emit('unNummerActive')" id="gefahrgutBestaetigen">Bestätigen</button><br>
        <button @click="$emit('eriActive')" id="eri-cards"  class="gefahrgutButtontype"><!--<span>--><img src="../../assets/Icons/ERI-CARDS.svg"><br>ERI-Cards<!--</span>--></button><!--<br>-->
        <button @click="this.openCamera()" id="openCamera" class="gefahrgutButtontype"><img src="../../assets/Icons/Gefahrguttafel.svg"><br>Scannen</button><br>
        <button @click="$emit('klassenActive')" id="gefahrgutKlassen" class="gefahrgutButtontype"><img src="../../assets/Icons/GefahrgutKlassen.svg"><br>Klassen</button>
        <button @click="$emit('ghsActive')" id="ghs" class="gefahrgutButtontype"><img src="../../assets/Icons/GHS.svg"><br>GHS</button>
        <input v-show="false" type="file" ref="fileInput" style="display: none" @change="uploadImage" accept="image/*">
    </div>
</template>

<script>
import Tesseract from 'tesseract.js';

export default {
    name: 'GeHome',
    props:{
        
    },
    data() {
        return{
            recognizedText: '',
        }
    },
    components: {
    },
    methods: {
        openCamera(){
            if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia){
                navigator.mediaDevices.getUserMedia({ video: true })
                .then((stream) => {
                const video = document.createElement('video');
                document.body.appendChild(video);
                video.srcObject = stream;
                video.play();
                
                this.$refs.fileInput.click(); // Trigger file input to capture image
                })
                .catch((error) => {
                console.error('Error accessing camera:', error);
                });
            } else{
                console.error('getUserMedia wird auf diesem Gerät nicht unterstützt.');
            }
        },
        uploadImage(event) {
            const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                const image = new Image();
                image.src = e.target.result;

                // Perform OCR using Tesseract.js
                Tesseract.recognize(
                image,
                'eng', // language code
                { logger: info => console.log(info) } // logger function
                ).then(({ data: { text } }) => {
                // 'text' contains the recognized text
                console.log('Recognized text:', text);

                // Now you can store 'text' in a variable or perform any other desired action
                // For example, you could use Vue.js data to store the text:
                this.$data.recognizedText = text;
                });
            };

            reader.readAsDataURL(file);
        },
    },
    created(){
    }
}
</script>

<style lang="scss">
#geHome{
    input, #gefahrnummer{
        padding: 0;
        margin: 0;
        width: 80%;
        height: 3.3rem;
        font-size: larger;
        margin-bottom: 0.4rem;
        border: solid black 2px;
        border-radius: 8px;
        text-align:center;
    }

    #gefahrgutBestaetigen{
        width: 60%;
        height: 3.3rem;
        font-size: larger;
        margin-bottom: 0.4rem;
        border: solid black 2px;
        border-radius: 8px;
        text-align:center;
        background-color: blue;
        color: white;
    }

    /*#eri-cards{
        margin-top: 3.3rem;
        width: 80%;
        height: 5rem;
        margin-bottom: 0.4rem;
        border: solid black 2px;
        border-radius: 8px;
        text-align:center;
        
        span{
            font-size: xx-large;
            width: 100%;
            height: 5rem;
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
    }*/

    .gefahrgutButtontype{
        width: 39%;
        height: 7.5rem;
        font-size:large;
        margin-bottom: 0.4rem;
        border: solid black 2px;
        border-radius: 8px;
        text-align:center;
    }

    #gefahrgutKlassen, #eri-cards{
        margin-right: 2%;
    }

    img{
        height: 70%;
        margin: 0;
        padding: 0;
    }
}
</style>